/**
 * Get initials from a person's name.
 * - If FirstName and LastName are available: use first letter of each (e.g., "K" + "M" = "KM")
 * - Otherwise, use first letter of FullName or fallback text
 */
export function getInitials(options) {
    const { firstName, lastName, fullName, fallback = '?' } = options;
    // If we have both first and last name, use first letter of each
    if (firstName && lastName) {
        const first = firstName.trim().slice(0, 1).toUpperCase();
        const last = lastName.trim().slice(0, 1).toUpperCase();
        return first + last;
    }
    // If we only have first name
    if (firstName && firstName.trim()) {
        return firstName.trim().slice(0, 1).toUpperCase();
    }
    // If we only have last name
    if (lastName && lastName.trim()) {
        return lastName.trim().slice(0, 1).toUpperCase();
    }
    // Fall back to full name first letter
    if (fullName && fullName.trim()) {
        return fullName.trim().slice(0, 1).toUpperCase();
    }
    // Ultimate fallback
    return fallback.slice(0, 1).toUpperCase();
}
/**
 * Get initials for a company name.
 * Uses first letter of company name.
 */
export function getCompanyInitials(companyName, fallback = '?') {
    if (companyName && companyName.trim()) {
        return companyName.trim().slice(0, 1).toUpperCase();
    }
    return fallback.slice(0, 1).toUpperCase();
}
